import { Injectable } from '@angular/core';
import { GenericConfig } from "@signature-it/ngx-generic/config";

@Injectable({
    providedIn: 'root'
})
export class GlobalLinkService {

    private originalWindowOpen: (url?: string | URL, target?: string, features?: string) => Window | null;

    constructor() {

        if (!GenericConfig.isMultiLanguages) return;

        console.log('GlobalLinkService initialized');

        // Set the original window.open after the condition check
        this.originalWindowOpen = window.open;

        // Override window.open
        this.overrideWindowOpen();

        // Listen for all click events on the document
        document.addEventListener('click', (event: MouseEvent) => {
            const target = event.target as HTMLAnchorElement;

            // Ensure the target is an anchor element
            if (target && target.tagName !== 'A') return;
            const href = target.getAttribute('href');
            if ((href && !href.startsWith('/')) || (href == '')) return;

            // Get the base URL
            const baseHref = this.getBaseHref();

            // Check if the href starts with the base href
            if (href.startsWith(baseHref)) return;

            // Prevent the default navigation
            event.preventDefault();

            // Remove the leading slash
            const newHref = href.substring(1);

            // Prepend the base href to the new href
            const fullHref = `${baseHref}${newHref}`;

            // Update the href attribute of the link
            target.setAttribute('href', fullHref);
            console.log('Navigating to:', fullHref); // Debug log

            // Optionally, navigate to the new URL
            window.location.href = fullHref;
        });
    }

    private overrideWindowOpen() {
        const baseHref = this.getBaseHref();
        window.open = (url?: string | URL, target?: string, features?: string) => {
            if (url && typeof url === 'string' && !url.startsWith('http') && !url.startsWith(baseHref)) {
                url = `${baseHref}${url}`;
            }
            return this.originalWindowOpen.call(window, url, target, features);
        };
    }

    private getBaseHref(): string {
        const baseElement = document.querySelector('base');
        return baseElement ? baseElement.getAttribute('href') || '/' : '/';
    }
}
